import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@xo-union/tk-component-buttons';
import styles from './index.scss';
import ThemeListImage from '../ThemeListImage';
import { Maybe } from '../../../generated/graphql';

interface Props {
  themeId: Maybe<number>;
  mediaId?: string;
  mediaUrl?: string;
  mobileMediaId?: string;
  mobileMediaUrl?: string;
  onClick: () => void;
  type?: string;
}

const ThemeListImageContainer: React.FC<Props> = ({
  themeId,
  mediaId,
  mediaUrl,
  mobileMediaId,
  mobileMediaUrl,
  onClick,
  type,
}) => {
  return (
    <Link
      to={`/gs/wedding-websites/designs/${themeId}`}
      data-testid="clickableTheme"
      onClick={onClick}
      className={styles.imageWrapper}
    >
      <ThemeListImage mediaId={mediaId} mediaUrl={mediaUrl} themeId={themeId} />
      <div className={styles.overlay}>
        <Button size="md" color="primary">
          See details
        </Button>
      </div>
    </Link>
  );
};

export default ThemeListImageContainer;
